import * as Yup from "yup";

export const publicationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  uri: Yup.string().url("Enter a valid URL").nullable(),
  date_published: Yup.date()
    .nullable()
    .max(new Date(), "Date cannot be in the future"),
  authors: Yup.string().nullable(),
  institution_id: Yup.string().required("Institution is required"),
});
